module.exports = __webpack_public_path__ + "img/default-profile.d874bd94.svg";